import React from 'react';
import BzmIcon from '../../icons/BzmIcon';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import PopoverContent from '../../overlays/Popover/PopoverContent';
import _ from 'lodash';
import CopyToClipboardButton from '../../buttons/CopyToClipboardButton';
import Button from 'react-bootstrap/Button';
import MixpanelService from '../../../utils/mixpanelService';
import {
  COPY_FULL_MOCK_SERVICE_ENDPOINT_WITHIN_GROUP,
  OPEN_MOCK_SERVICE_BASE_PATH_POPOVER,
} from '../../../utils/mixpanelEvents';

interface CopyEndpointPopoverProps {
  endpoint: string;
}

/**
 * Icon with popover with endpoint value and copy action.
 * @param props
 * @constructor
 */
const CopyEndpointPopover = (props: CopyEndpointPopoverProps) => {
  const getPopover = () => {
    return (
      <Popover id={'copyEndpoint-' + _.uniqueId()}>
        <PopoverContent>
          <PopoverContent.Header>
            <h5 className={'font-weight-semi-bold'}>Virtual Service Endpoint</h5>
          </PopoverContent.Header>
          <PopoverContent.Body>
            <div>
              {props.endpoint}
              <CopyToClipboardButton textToCopy={props.endpoint} title={props.endpoint}>
                <BzmIcon
                  onClick={() => {
                    MixpanelService.track(COPY_FULL_MOCK_SERVICE_ENDPOINT_WITHIN_GROUP());
                  }}
                  variant={'icon-bzm-clipboard'}
                  title={'Copy full Virtual Service Endpoint.'}
                />
              </CopyToClipboardButton>
            </div>
          </PopoverContent.Body>
        </PopoverContent>
      </Popover>
    );
  };

  return (
    <OverlayTrigger trigger={'click'} placement={'bottom'} rootClose={true} overlay={getPopover()}>
      <Button
        onClick={() => {
          MixpanelService.track(OPEN_MOCK_SERVICE_BASE_PATH_POPOVER());
        }}
        className={'btn p-0 m-0 btn-no-hover'}
        variant={'link'}
      >
        <BzmIcon variant={'icon-bzm-link'} title={'Full Virtual Service Endpoint'} />
      </Button>
    </OverlayTrigger>
  );
};

export default CopyEndpointPopover;
